import {
	ChangeEmailAndPasswordAction,
	PortalErrors,
} from './change-email-and-password';
import { HTTP_STATUS_BAD_REQUEST, HTTP_STATUS_INTERNAL_SERVER_ERROR, HTTP_STATUS_OK } from '../../../helpers/validation/common';

const successMock: ChangeEmailAndPasswordAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_OK,
		playerId: 12345,
		redirectUrl: 'https://example.com/browser-session/?token=12345:mocked-token',
	});
};

const emailConflictMock: ChangeEmailAndPasswordAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_BAD_REQUEST,
		error: PortalErrors.EmailConflict,
	});
};

const emailInvalidFormatMock: ChangeEmailAndPasswordAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_BAD_REQUEST,
		error: PortalErrors.EmailInvalidFormat,
	});
};

const emailBlacklistedMock: ChangeEmailAndPasswordAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_BAD_REQUEST,
		error: PortalErrors.EmailBlacklisted,
	});
};

const internalErrorMock: ChangeEmailAndPasswordAction = async () => {
	return Promise.resolve({
		status: HTTP_STATUS_INTERNAL_SERVER_ERROR,
	});
};

export const changeEmailAndPasswordMocks: {
	success: ChangeEmailAndPasswordAction;
	emailConflict: ChangeEmailAndPasswordAction;
	emailInvalidFormat: ChangeEmailAndPasswordAction;
	emailBlacklisted: ChangeEmailAndPasswordAction;
	internalError: ChangeEmailAndPasswordAction;
	fail: ChangeEmailAndPasswordAction;
} = {
	success: successMock,
	emailConflict: emailConflictMock,
	emailInvalidFormat: emailInvalidFormatMock,
	emailBlacklisted: emailBlacklistedMock,
	internalError: internalErrorMock,
	fail: internalErrorMock,
};
